import React from 'react';
import { ArrowLeft, MoreVertical, Smile, Send } from 'lucide-react';
import WhatsAppIcon from 'components/ui/icons/WhatsAppIcon';

const WhatsAppConversationPreview = ({ campaignPreview, user }) => {
  const businessName = user?.business_name || 'Tu Negocio';
  const businessLogo = user?.business_logo || 'Tu Negocio';

  const autoFillMessage = campaignPreview?.meta_settings?.whatsapp_settings?.autofill_message || `¡Hola! Me gustaría saber más de la promoción`;
  const welcomeMessage = campaignPreview?.meta_settings?.whatsapp_settings?.page_welcome_message || `¡Hola! ¿Cómo podemos ayudarte?`;

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300">
      <div className="relative w-72 h-[422px]">
        {/* Conversation frame - using full container */}
        <div className="absolute inset-0 bg-gray-100 rounded-lg overflow-hidden">
          {/* Header */}
          <div className="absolute top-0 left-0 right-0 z-10 bg-green-600 text-white px-3 py-2 flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <button className="text-white hover:text-gray-200">
                <ArrowLeft className="w-4 h-4" />
              </button>
              <div className="w-6 h-6 bg-gradient-to-r from-green-400 to-green-600 rounded-full flex items-center justify-center text-white font-bold text-xs">
                {(businessLogo || 'Tu Negocio')[0] || 'T'}
              </div>
              <div>
                <div className="font-semibold text-xs">{businessName}</div>
                <div className="text-xs text-green-100">Cuenta comercial</div>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center">
                <WhatsAppIcon width={24} height={24} />
              </div>
              <button className="text-white hover:text-gray-200">
                <MoreVertical className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Chat Area */}
          <div 
            className="absolute top-12 left-0 right-0 bottom-12 bg-gray-50 p-3 overflow-y-auto"
          >
            <div className="space-y-2">
              {/* Ad Card Message */}
              <div className="flex justify-start">
                <div className="max-w-[200px] bg-white rounded-lg shadow-sm p-2">
                  <div className="flex items-start space-x-2">
                    <div className="w-8 h-8 bg-gray-200 rounded flex items-center justify-center">
                      <div className="w-6 h-6 bg-white rounded border"></div>
                    </div>
                    <div className="flex-1">
                      <div className="font-semibold text-xs text-gray-900">Anuncio</div>
                      <div className="text-xs text-gray-500">Ver detalles</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Automated Greeting Message */}
              <div className="flex justify-start">
                <div className="max-w-[200px] bg-white rounded-lg shadow-sm p-2">
                  <div className="text-xs text-gray-900">{welcomeMessage}</div>
                  <div className="text-xs text-gray-500 text-right">Saludo automático</div>
                </div>
              </div>


            </div>
          </div>

          {/* Input Bar */}
          <div className="absolute bottom-0 left-0 right-0 bg-white px-3 py-2 flex items-center space-x-2">
            <button className="text-gray-500 hover:text-gray-700">
              <Smile className="w-4 h-4" />
            </button>
            <div className="flex-1 bg-gray-100 rounded-full px-4 py-3">
              <textarea
                value={autoFillMessage}
                className="w-full bg-transparent text-xs outline-none resize-none overflow-hidden"
                rows="2"
                readOnly
                style={{ minHeight: '24px', maxHeight: '80px' }}
              />
            </div>
            <button className="bg-green-500 hover:bg-green-600 text-white p-2 rounded-full transition-colors">
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppConversationPreview; 